import { render } from "./IntertextListing.vue?vue&type=template&id=68716a54&ts=true"
import script from "./IntertextListing.vue?vue&type=script&lang=ts"
export * from "./IntertextListing.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__